export const Tabs = {
    FullTime: 'full_time',
    FirstHalf: 'first_half',
    SecondHalf: 'second_half',
}